/* ============================================================
   TAILWIND — Theme JS
   Scroll cue, video carousel, product media gallery, recommendations
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Scroll cue ---------- */
  var cue = document.getElementById('scrollCue');
  if (cue) {
    cue.addEventListener('click', function () {
      window.scrollBy({ top: window.innerHeight * 0.85, behavior: 'smooth' });
    });
    function updateCue() {
      var scrolled = window.scrollY + window.innerHeight;
      var total = document.documentElement.scrollHeight;
      cue.classList.toggle('is-hidden', (total - scrolled) < 220);
    }
    window.addEventListener('scroll', updateCue, { passive: true });
    window.addEventListener('resize', updateCue);
    updateCue();
  }

  /* ---------- Video carousel(s) ---------- */
  document.querySelectorAll('[id^="videoCarousel-"]').forEach(function (carousel) {
    var track = carousel.querySelector('.carousel-track');
    if (!track) return;
    var slides = Array.from(track.querySelectorAll('.cslide'));
    if (!slides.length) return;
    var section = carousel.closest('.videostrip');
    var prev = section && section.querySelector('[data-target="' + carousel.id + '"].cbtn-prev');
    var next = section && section.querySelector('[data-target="' + carousel.id + '"].cbtn-next');
    var pos = section && section.querySelector('.cposCurrent');
    var idx = 0;
    var timer = null;

    function slideWidth() { return slides[0].offsetWidth + 16; }
    function go(i) {
      idx = (i + slides.length) % slides.length;
      carousel.scrollTo({ left: idx * slideWidth(), behavior: 'smooth' });
      if (pos) pos.textContent = String(idx + 1).padStart(2, '0');
    }
    function start() { if (!timer) timer = setInterval(function(){ go(idx + 1); }, 6000); }
    function stop()  { clearInterval(timer); timer = null; }

    if (next) next.addEventListener('click', function () { stop(); go(idx + 1); });
    if (prev) prev.addEventListener('click', function () { stop(); go(idx - 1); });
    carousel.addEventListener('pointerdown', stop);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
      }, { threshold: 0.25 });
      io.observe(carousel);
    } else {
      start();
    }

    var sx;
    carousel.addEventListener('scroll', function () {
      clearTimeout(sx);
      sx = setTimeout(function () {
        var nearest = Math.round(carousel.scrollLeft / slideWidth());
        if (nearest !== idx) {
          idx = Math.max(0, Math.min(slides.length - 1, nearest));
          if (pos) pos.textContent = String(idx + 1).padStart(2, '0');
        }
      }, 80);
    });
  });

  /* ---------- Product media gallery (thumbs + fraction + swipe) ---------- */
  document.querySelectorAll('.product-media').forEach(function (galleryRoot) {
    var stage = galleryRoot.querySelector('[data-pp-stage]');
    var items = Array.from(galleryRoot.querySelectorAll('.product-media-item'));
    var thumbs = Array.from(galleryRoot.querySelectorAll('[data-thumb-index]'));
    var fracCurrent = galleryRoot.querySelector('[data-pp-fraction] .gallery-fraction-current');
    var fracTotal   = galleryRoot.querySelector('[data-pp-fraction] .gallery-fraction-total');
    if (!items.length) return;

    // Init fraction
    if (fracTotal) fracTotal.textContent = items.length;
    if (fracCurrent) fracCurrent.textContent = '1';

    function goTo(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      items.forEach(function (it, j) { it.classList.toggle('is-active', i === j); });
      thumbs.forEach(function (b, j) { b.classList.toggle('is-active', i === j); });
      if (fracCurrent) fracCurrent.textContent = String(i + 1);
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(parseInt(btn.getAttribute('data-thumb-index'), 10));
      });
    });

    // Touch swipe support
    if (stage) {
      var touchStartX = 0;
      var currentIdx = 0;
      stage.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        currentIdx = items.findIndex(function(it) { return it.classList.contains('is-active'); });
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) goTo(currentIdx + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
  });

  /* ---------- Product recommendations fetch ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (sectionEl) {
    var url = sectionEl.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh) sectionEl.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* silent */ });
  });

  /* ---------- Cart count update on form submit (basic) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action$="/cart/add"]')) return;
    setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var c = document.getElementById('cart-count');
          if (c) c.textContent = cart.item_count;
        });
    }, 300);
  });

})();
